export const HISTORY_MAX_LENGTH = 20;  // Max conversation messages sent to API (10 back-and-forth turns). Gemini 2.5 has 1M token context; pills are stripped before sending so this is lean.

// Starter Prompt Chips
export type StarterChip = {
    id: string;
    label: string;
    prompt: string;
};

export const OSP_STARTER_CHIPS: StarterChip[] = [

    {
        id: "logic",
        label: "Analytický oddíl",
        prompt: "Procvič se mnou úlohy z analytického oddílu."
    },
    {
        id: "verbal",
        label: "Verbální oddíl",
        prompt: "Procvič se mnou úlohy z verbálního oddílu."
    },
];

export const INITIAL_GREETING = "Dobrý den. Jsem váš strategický kouč pro OSP 2026 z projektu Dostaň se na práva. Pamatujte, u Scio testů nevyhrává ten nejvzdělanější, ale ten, kdo má nejpřesnější algoritmy. S jakou výzvou dnes začneme?";
